export { default as Button } from './Button/Button';
export { default as InputText } from './InputText/InputText';
export { default as InputBirthday } from './InputBirthday/InputBirthday';
export { default as ContactPhoneButton } from './ContactButton/ContactButton';
export { default as InputPhoneNumber } from './InputPhoneNumber/InputPhoneNumber';
export { default as CheckBox } from './CheckBox/CheckBox';
export { default as TagButton } from './TagButton/TagButton';

export { default as Select } from './Select/Select';
export { default as NumberInputWithSelect } from './NumberInputWithSelect/NumberInputWithSelect';
export {
  default as InputPriceWithCurrencies,
} from './InputPriceWithCurrencies/InputPriceWithCurrencies';



// WEBPACK FOOTER //
// ./src/shared/components/UI/index.js